import React from "react";
import AssessmentRouter from './assessment/Router';
export { getFields } from './assessment/Router';

export default function AssessmentPMTimeRouter(props){
    return <AssessmentRouter {...props} mode='PM_TIME' />;
}